<div class="flex flex-column w-full h-screen min-h-screen">
  <!-- Navigation -->
  <medsurf-navbar></medsurf-navbar>
  <!-- Toolbar -->
  <medsurf-design-content-toolbar class="mb-2">
    <div class="p-toolbar-group-start">
      <button medsurf-design-input-button id="back_to_overview"
        [label]="'global.back_to_overview' | translate"
        [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.BACK"
      routerLink="/copyrights"></button>
    </div>
  </medsurf-design-content-toolbar>
  <!-- Content -->
  <div class="flex flex-1 overflow-auto justify-content-center align-self-center w-11 lg:w-5 mb-2">
    <div class="flex flex-column row-gap-2 w-full">
      <medsurf-design-content-panel titleText="global.copyright">
        <!-- Form -->
        @if (copyrightForm) {
          <medsurf-design-form-control-form
            [formGroup]="copyrightForm"
            (onSubmit)="onSubmit()">
            <!-- Text -->
            <medsurf-design-form-control-input-text #textInputText
              [control]="copyrightForm.controls.text"
            label="global.text"></medsurf-design-form-control-input-text>
            <!-- Submit -->
            <medsurf-design-form-control-input-submit [disabled]="copyrightForm.invalid || isSubmitted()"
            label="global.save_changes"></medsurf-design-form-control-input-submit>
          </medsurf-design-form-control-form>
        }
      </medsurf-design-content-panel>
      <!-- Delete Panel -->
      <medsurf-design-content-panel titleText="global.copyright_remove"
        [hidden]="(constantAuthorFacade.copyright$ | async) === undefined">
        <button medsurf-design-input-button id="copyright_remove"
          [label]="'global.remove' | translate"
          [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.DANGER"
          [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.REMOVE"
        (click)="deleteCopyright()"></button>
      </medsurf-design-content-panel>
    </div>
  </div>
</div>
